export function computeComplexAlphaMinus() {
  throw 'not supported in multiple-feedback';
}

export function computeComplexFF() {
  throw 'not supported in multiple-feedback';
}
